import BipPath from 'bip32-path';
import * as util from './util.js';
import { ModelIdSymbol } from '../constants.js';
import { createIsInstance, omitUndefined } from '../utils.js';
import { isKeyIdentifierLike } from './util.js';
export default class Address {
    address;
    meta;
    constructor(address, meta) {
        this.address = address;
        this.meta = meta || Object.create(null);
    }
    static get [ModelIdSymbol]() {
        return 'Address';
    }
    static isInstance = createIsInstance(Address);
    static [Symbol.hasInstance](instance) {
        return this.isInstance(instance);
    }
    static create(address, meta) {
        return Object.freeze(new Address(address, meta));
    }
    static fromJSON(json) {
        const data = typeof json === 'string' ? JSON.parse(json) : json;
        return Address.create(data.address, data.meta || data.path);
    }
    get pathArray() {
        return BipPath.fromString(this.meta.path || 'm/0/0').toPathArray();
    }
    toJSON() {
        return {
            address: this.address,
            meta: this.meta,
        };
    }
    toRedactedJSON() {
        const redactedMeta = {
            path: this.meta.path,
            purpose: this.meta.purpose,
        };
        if (typeof this.meta.walletAccount === 'string') {
            redactedMeta.walletAccount = this.meta.walletAccount;
        }
        if (isKeyIdentifierLike(this.meta.keyIdentifier)) {
            const { derivationAlgorithm, keyType, derivationPath, assetName } = this.meta.keyIdentifier;
            redactedMeta.keyIdentifier = omitUndefined({
                derivationAlgorithm,
                keyType,
                derivationPath,
                assetName,
            });
        }
        return {
            address: this.address,
            meta: omitUndefined(redactedMeta),
        };
    }
    toString() {
        return this.address;
    }
    get [Symbol.toStringTag]() {
        return this.address;
    }
    static isAddress(address) {
        return (typeof address === 'object' &&
            address !== null &&
            (address instanceof Address || ('address' in address && 'meta' in address)));
    }
    static util = util;
}
